import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { en } from '../translations/en';
import { cs } from '../translations/cs';
import { de } from '../translations/de';

Vue.use(VueI18n);

const messages = {
    'en': en,
    'cs': cs,
    'de': de
};

const lang = navigator.language;

console.log(lang);

export const i18n = new VueI18n({ locale: 'en', fallbackLocale: 'en', messages });